// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable no-unused-vars */
import { FormControlLabel, styled, Switch } from "@mui/material";
import { IconEdit, IconPlus, IconTrash } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import { getSetting, handleSetting, maintenanceMode, updateSetting } from "../../../redux/slice/settingSlice";
import { getWithDraw, statusWithDraw, withDrawDelete } from "../../../redux/slice/withDrawSlice";
import { permissionError, warning } from "../../../util/Alert";
import Button from "../../extras/Button";
import MultiButton from "../../extras/MultiButton";
import Pagination from "../../extras/Pagination";
import Table from "../../extras/Table";
import ToggleSwitch from "../../extras/ToggleSwitch";
import WithDrawDialogue from "../WithDrawDialogue";
import LazyImage from "../../extras/ImageFallback";

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: "76px",
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    top: "8px",
    transform: "translateX(10px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(38px)",
      top: "8px",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M16.5992 5.06724L16.5992 5.06719C16.396 4.86409 16.1205 4.75 15.8332 4.75C15.546 4.75 15.2705 4.86409 15.0673 5.06719L15.0673 5.06721L7.91657 12.2179L4.93394 9.23531C4.83434 9.13262 4.71537 9.05067 4.58391 8.9942C4.45174 8.93742 4.30959 8.90754 4.16575 8.90629C4.0219 8.90504 3.87925 8.93245 3.74611 8.98692C3.61297 9.04139 3.49202 9.12183 3.3903 9.22355C3.28858 9.32527 3.20814 9.44622 3.15367 9.57936C3.0992 9.7125 3.07179 9.85515 3.07304 9.99899C3.07429 10.1428 3.10417 10.285 3.16095 10.4172C3.21742 10.5486 3.29937 10.6676 3.40205 10.7672L7.15063 14.5158L7.15066 14.5158C7.35381 14.7189 7.62931 14.833 7.91657 14.833C8.20383 14.833 8.47933 14.7189 8.68249 14.5158L8.68251 14.5158L16.5992 6.5991L16.5992 6.59907C16.8023 6.39592 16.9164 6.12042 16.9164 5.83316C16.9164 5.54589 16.8023 5.27039 16.5992 5.06724Z" fill="white" stroke="white" stroke-width="0.5"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette === "dark" ? "#0FB515" : "red",
    width: 24,
    height: 24,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M14.1665 5.83301L5.83325 14.1663" stroke="white" stroke-width="2.5" stroke-linecap="round"/><path d="M5.83325 5.83301L14.1665 14.1663" stroke="white" stroke-width="2.5" stroke-linecap="round"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: "52px",
    border: "0.5px solid rgba(0, 0, 0, 0.14)",
    background: " #FFEDF0",
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.08) inset",
    opacity: 1,
    width: "60px",
    height: "28px",
    borderRadius: "52px",
  },
}));

const Setting = (props) => {
  const dispatch = useDispatch();
  const { setting } = useSelector((state) => state.setting);
  const { withDraw } = useSelector((state) => state.withDraw);

  const hasPermission = useSelector((state) => state.auth.admin.flag);
  const [type, setType] = useState("setting");
  const [initialValues, setInitialValues] = useState({});
  const [privacyPolicyLink, setPrivacyPolicyLink] = useState();
  const [tnc, setTnc] = useState();
  const [tax, setTax] = useState();

  const [razorPayId, setRazorPayId] = useState("");
  const [razorSecretKey, setRazorSecretKey] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const [cancelOrderCharges, setCancelOrderCharges] = useState("");
  const [adminCommissionCharges, setAdminCommissionCharges] = useState("");
  const [data, setData] = useState([]);
  console.log("withDrawwithDraw", withDraw);
  // box 5
  const [stripePublishableKey, setStripePublishableKey] = useState("");
  const [stripeSecretKey, setStripeSecretKey] = useState("");

  const [minWithdrawalRequestedAmount, setMinWithdrawalRequestedAmount] = useState("");
  const [currencyName, setCurrencyName] = useState();
  const [currencySymbol, setCurrencySymbol] = useState();
  const [flutterWaveKey, setFlutterWaveKey] = useState();
  const [resendKey, setResendKey] = useState();

  const [firebaseKey, setfirebaseKey] = useState();
  const [isAddProduct, setIsAddProduct] = useState(false);
  const [isUpdateProduct, setIsUpdateProduct] = useState(false);

  const [androidAppVersion, setAndroidAppVersion] = useState("");
  const [androidAppLink, setAndroidAppLink] = useState("");
  const [iosAppVersion, setIosAppVersion] = useState("");
  const [iosAppLink, setIosAppLink] = useState("");

  const [googlePlayEmail, setGooglePlayEmail] = useState("");
  const [googlePlayKey, setGooglePlayKey] = useState("");

  const [cashfreeClientId, setCashfreeClientId] = useState("");
  const [cashfreeClientSecret, setCashfreeClientSecret] = useState("");

  const [paystackPublicKey, setPaystackPublicKey] = useState("");
  const [paystackSecretKey, setPaystackSecretKey] = useState("");

  const [paypalClientId, setPaypalClientId] = useState("");
  const [paypalSecretKey, setPaypalSecretKey] = useState("");

  const [nowPaymentApiKey, setNowPaymentApiKey] = useState("");
  const [nowPaymentSandboxKey, setNowPaymentSandboxKey] = useState("");
  const [nowPaymentIpnSecret, setNowPaymentIpnSecret] = useState("");
  const [nowPaymentPayCurrency, setNowPaymentPayCurrency] = useState("");

  const [error, setError] = useState({
    firebaseKey: "",
    privacyPolicyLink: "",
    tnc: "",
    stripePublishableKey: "",
    stripeSecretKey: "",
    razorPayId: "",
    razorSecretKey: "",
    tax: "",
    currencyName: "",
    currencySymbol: "",
    flutterWaveKey: "",
    resendKey: "",
    androidAppVersion: "",
    androidAppLink: "",
    iosAppVersion: "",
    iosAppLink: "",
    googlePlayEmail: "",
    googlePlayKey: "",
    cashfreeClientId: "",
    cashfreeClientSecret: "",
    paystackPublicKey: "",
    paystackSecretKey: "",
    paypalClientId: "",
    paypalSecretKey: "",
    nowPaymentApiKey: "",
    nowPaymentSandboxKey: "",
    nowPaymentIpnSecret: "",
    nowPaymentPayCurrency: "",
  });

  useEffect(() => {
    const payload = {
      start: page,
      limit: rowsPerPage,
    };
    dispatch(getWithDraw(payload));
  }, [type, page, rowsPerPage]);

  useEffect(() => {
    if (hasPermission) dispatch(getSetting());
  }, [dispatch, hasPermission]);

  useEffect(() => {
    setData(withDraw);
  }, [withDraw]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  useEffect(() => {
    if (setting) {
      setCurrencyName(setting.currencyName);
      setCurrencySymbol(setting.currencySymbol);
      setStripePublishableKey(setting.stripePublishableKey);
      setStripeSecretKey(setting.stripeSecretKey);
      setRazorPayId(setting.razorPayId);
      setRazorSecretKey(setting.razorSecretKey);
      setTax(setting.tax);
      setPrivacyPolicyLink(setting?.privacyPolicyLink);
      setTnc(setting.tnc);
      setResendKey(setting?.resendApiKey);
      setFlutterWaveKey(setting.flutterWaveKey);
      setfirebaseKey(JSON.stringify(setting.firebaseKey));
      setIsAddProduct(setting?.isAddProductRequest);
      setIsUpdateProduct(setting?.isUpdateProductRequest);
      setMinWithdrawalRequestedAmount(setting?.minWithdrawalRequestedAmount);
      setAdminCommissionCharges(setting?.adminCommissionCharges);
      setCancelOrderCharges(setting?.cancelOrderCharges);
      setAndroidAppVersion(setting?.androidAppVersion);
      setAndroidAppLink(setting?.androidAppLink);
      setIosAppVersion(setting?.iosAppVersion);
      setIosAppLink(setting?.iosAppLink);
      setGooglePlayEmail(setting?.googlePlayEmail);
      setGooglePlayKey(setting?.googlePlayKey);
      setCashfreeClientId(setting?.cashfreeClientId);
      setCashfreeClientSecret(setting?.cashfreeClientSecret);
      setPaystackPublicKey(setting?.paystackPublicKey);
      setPaystackSecretKey(setting?.paystackSecretKey);
      setPaypalClientId(setting?.paypalClientId);
      setPaypalSecretKey(setting?.paypalSecretKey);
      setNowPaymentApiKey(setting?.nowPaymentApiKey);
      setNowPaymentSandboxKey(setting?.nowPaymentSandboxKey);
      setNowPaymentIpnSecret(setting?.nowPaymentIpnSecret);
      setNowPaymentPayCurrency(setting?.nowPaymentPayCurrency);

      setInitialValues({
        privacyPolicyLink: setting?.privacyPolicyLink,
        tnc: setting.tnc,
        stripePublishableKey: setting.stripePublishableKey,
        stripeSecretKey: setting.stripeSecretKey,
        razorPayId: setting.razorPayId,
        razorSecretKey: setting.razorSecretKey,
        tax: setting.tax,
        currencyName: setting.currencyName,
        currencySymbol: setting.currencySymbol,
        flutterWaveKey: setting.flutterWaveKey,
        firebaseKey: JSON.stringify(setting.firebaseKey),
        resendApiKey: setting?.resendApiKey,
        minWithdrawalRequestedAmount: setting?.minWithdrawalRequestedAmount,
        cancelOrderCharges: setting?.cancelOrderCharges,
        adminCommissionCharges: setting?.adminCommissionCharges,
        androidAppVersion: setting?.androidAppVersion,
        androidAppLink: setting?.androidAppLink,
        iosAppVersion: setting?.iosAppVersion,
        iosAppLink: setting?.iosAppLink,
        googlePlayEmail: setting?.googlePlayEmail,
        googlePlayKey: setting?.googlePlayKey,
        cashfreeClientId: setting?.cashfreeClientId,
        cashfreeClientSecret: setting?.cashfreeClientSecret,
        paystackPublicKey: setting?.paystackPublicKey,
        paystackSecretKey: setting?.paystackSecretKey,
        paypalClientId: setting?.paypalClientId,
        paypalSecretKey: setting?.paypalSecretKey,
        nowPaymentApiKey: setting?.nowPaymentApiKey,
        nowPaymentSandboxKey: setting?.nowPaymentSandboxKey,
        nowPaymentIpnSecret: setting?.nowPaymentIpnSecret,
        nowPaymentPayCurrency: setting?.nowPaymentPayCurrency,
      });
    }
  }, [setting]);

  const getCurrentValues = () => ({
    privacyPolicyLink,
    tnc,
    stripePublishableKey,
    stripeSecretKey,
    razorPayId,
    razorSecretKey,
    tax,
    currencyName,
    currencySymbol,
    flutterWaveKey,
    firebaseKey,
    resendApiKey: resendKey,
    minWithdrawalRequestedAmount,
    cancelOrderCharges,
    adminCommissionCharges,
    androidAppVersion,
    androidAppLink,
    iosAppVersion,
    iosAppLink,
    googlePlayEmail,
    googlePlayKey,
    cashfreeClientId,
    cashfreeClientSecret,
    paystackPublicKey,
    paystackSecretKey,
    paypalClientId,
    paypalSecretKey,
    nowPaymentApiKey,
    nowPaymentSandboxKey,
    nowPaymentIpnSecret,
    nowPaymentPayCurrency,
  });

  const isFormDirty = () => {
    const current = getCurrentValues();
    return Object.keys(current).some(key => current[key] != initialValues[key]);
  };

  const onsubmit = async (e) => {
    if (!hasPermission) return permissionError();
    e.preventDefault();
    if (!isFormDirty()) {
      toast.info("No changes detected.");
      return;
    }
    if (
      !privacyPolicyLink ||
      !tnc ||
      !stripePublishableKey ||
      !stripeSecretKey ||
      !razorPayId ||
      !razorSecretKey ||
      !tax ||
      !currencyName ||
      !resendKey ||
      !currencySymbol ||
      !flutterWaveKey ||
      !firebaseKey ||
      !adminCommissionCharges ||
      !cancelOrderCharges ||
      !androidAppVersion ||
      !androidAppLink ||
      !iosAppVersion ||
      !iosAppLink ||
      !googlePlayEmail ||
      !googlePlayKey ||
      !cashfreeClientId ||
      !cashfreeClientSecret ||
      !paystackPublicKey ||
      !paystackSecretKey ||
      !paypalClientId ||
      !paypalSecretKey ||
      !nowPaymentApiKey ||
      !nowPaymentSandboxKey ||
      !nowPaymentIpnSecret ||
      !nowPaymentPayCurrency
    ) {
      let error = {};
      if (!privacyPolicyLink) error.privacyPolicyLink = "Privacy Policy Link is required";
      if (!tnc) error.tnc = "T&C is required";
      if (!stripePublishableKey) error.stripePublishableKey = "Stripe Publishable Key is required";
      if (!stripeSecretKey) error.stripeSecretKey = "Stripe Secret Key is required";
      if (!razorPayId) error.razorPayId = "Razor Pay Id is required";
      if (!razorSecretKey) error.razorSecretKey = "Razor Secret Key is required";
      if (!tax) error.tax = "Tax is required";
      if (!currencyName) error.currencyName = "Currency Name is required";
      if (!currencySymbol) error.currencySymbol = "Currency Symbol is required";
      if (!flutterWaveKey) error.flutterWaveKey = "Flutter Wave Key is required";
      if (!firebaseKey) error.firebaseKey = "Firebase Key is required";
      if (!resendKey) error.resendKey = "Resend API Key is required";
      if (!adminCommissionCharges) error.commissionPerProductQuantity = "commissionPerProductQuantity Key is required";
      if (!cancelOrderCharges) error.cancelOrderCharges = "cancelOrderCharges Key is required";
      if (!minWithdrawalRequestedAmount) error.minWithdrawalRequestedAmount = "withDrawReq is required";

      if (!androidAppVersion) error.androidAppVersion = "Android App Version is Required";
      if (!androidAppLink) error.androidAppLink = "Android App Link is Required";
      if (!iosAppVersion) error.iosAppVersion = "IOS App Version is Required";
      if (!iosAppLink) error.iosAppLink = "IOS App Link is Required";

      if (!googlePlayEmail) error.googlePlayEmail = "Google Play Email Required";
      if (!googlePlayKey) error.googlePlayKey = "Google Play Key Required";
      if (!paystackPublicKey) error.paystackPublicKey = "Paystack Public Key Is Required !";
      if (!paystackSecretKey) error.paystackSecretKey = "Paystack Secret Key Is Required !";
      if (!cashfreeClientId) error.cashfreeClientId = "Cashfree Client Id Is Required !";
      if (!cashfreeClientSecret) error.cashfreeClientSecret = "Cashfree Client Secret Is Required !";
      if (!paypalClientId) error.paypalClientId = "Paypal Client Id Is Required !";
      if (!paypalSecretKey) error.paypalSecretKey = "Paypal Secret Key Is Required !";
      if (!nowPaymentApiKey) error.nowPaymentApiKey = "Now Payment Api Key Is Required !";
      if (!nowPaymentSandboxKey) error.nowPaymentSandboxKey = "Now Payment Sandbox Key Is Required !";
      if (!nowPaymentIpnSecret) error.nowPaymentIpnSecret = "Now Payment Ipn Secret Is Required !";
      if (!nowPaymentPayCurrency) error.nowPaymentPayCurrency = "Now Payment Pay Currency Is Required !";
      return setError({ ...error });
    } else {
      const current = getCurrentValues();
      const changedData = {};
      Object.keys(current).forEach(key => {
        if (current[key] != initialValues[key]) {
          changedData[key] = current[key];
        }
      });
      const payload = { data: changedData, id: setting?._id };
      await dispatch(updateSetting(payload)).unwrap();
    }
  };

  const handleSettingSwitch = (id, type) => {
    // if (!hasPermission) return permissionError();
    const payload = {
      id,
      type,
    };
    dispatch(handleSetting(payload));
  };

  const handleDelete = (id) => {
    // if (!hasPermission) return permissionError();
    const data = warning("Delete");
    data
      .then((logouts) => {
        const yes = logouts.isConfirmed;
        console.log("yes", yes);
        if (yes) {
          dispatch(withDrawDelete(id)).then((res) => {
            if (res?.payload?.status) {
              toast.success(res?.payload?.message);
              const payload = {
                start: page,
                limit: rowsPerPage,
              };
              dispatch(getWithDraw(payload));
            }
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleAppActive = (id) => {
    if (!hasPermission) return permissionError();
    dispatch(maintenanceMode(id));
  };

  const fakeFirebaseJson = {
    type: "service_account",
    project_id: "demo-project-12345",
    private_key_id: "fakeprivatekeyid1234567890abcdef",
    private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0FAKEFAASCBKcwggSjAgEAAoIBAQDUMMYKEYEXAMPLE\n-----END PRIVATE KEY-----\n",
    client_email: "firebase-adminsdk-abcde@demo-project-12345.iam.gserviceaccount.com",
    client_id: "123456789012345678901",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url: "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-abcde%40demo-project-12345.iam.gserviceaccount.com",
    universe_domain: "googleapis.com",
  };

  const withDrawTable = [
    {
      Header: "No",
      Cell: ({ index }) => <span>{page * rowsPerPage + parseInt(index) + 1}</span>,
    },

    {
      Header: "Image",
      Cell: ({ row }) => <LazyImage src={row?.image} alt={""} style={{ height: "50px", width: "50px", overflow: "hidden" }} />,
    },
    {
      Header: "Name",
      Cell: ({ row }) => <span className="text-capitalize ">{row?.name}</span>,
    },
    {
      Header: "Details",
      Cell: ({ row }) => {
        const details = row?.details?.join(", ");
        const words = details?.split(" ");
        const trimmedDetails = words?.length > 10 ? words?.slice(0, 10)?.join(" ") + "..." : details;

        return <span className="text-capitalize ">{trimmedDetails}</span>;
      },
    },
    {
      Header: "Created At",
      Cell: ({ row }) => <span className="text-capitalize">{row?.createdAt?.split("T")[0]}</span>,
    },
    {
      Header: "Active",
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.isEnabled}
          onClick={() => {
            if (!hasPermission) return permissionError();
            dispatch(statusWithDraw(row?._id)).then((res) => {
              if (res?.payload?.status) {
                toast.success(res?.payload?.message);
                dispatch(getWithDraw({ start: page, limit: rowsPerPage }));
              }
            });
          }}
        />
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <>
          <div className="action-button">
            <button
              className="btn btn-sm"
              onClick={() => {
                dispatch(openDialog({ type: "withdraw", data: row }));
              }}
            >
              <IconEdit className="text-secondary" />
            </button>
            <button
              className="btn btn-sm"
              onClick={() => {
                handleDelete(row?._id);
              }}
            >
              <IconTrash className="text-secondary" />
            </button>
          </div>
          {/* <span>
            <button
              className="py-1 me-2"
              style={{ backgroundColor: "#CFF3FF", borderRadius: "8px" }}
              onClick={() => {
                handleDelete(row?._id);
              }}
            >
              <Delete />
            </button>
          </span> */}
        </>
      ),
    },
  ];

  return (
    <div className="userPage">
      <div className="multi-user-btn mb-3 ">
        <MultiButton multiButtonSelect={type} setMultiButtonSelect={setType} label={["Setting", "Payment Setting", "Withdraw Setting"]} />
      </div>
      {/* <div
        className="my-2"
        style={{
          width: '350px',
          border: '1px solid #1c2b20',
          padding: '8px 20px',
          borderRadius: '40px',
        }}
      >
        <button
          type="button"
          className={`${type === 'setting' ? 'activeBtn' : 'disabledBtn'}`}
          onClick={() => setType('setting')}
        >
          Setting
        </button>
        <button
          type="button"
          className={`${
            type === 'paymentSetting' ? 'activeBtn' : 'disabledBtn'
          }`}
          onClick={() => setType('paymentSetting')}
        >
          Payment
        </button>
        <button
          type="button"
          className={`${
            type === 'withdraw' ? 'activeBtn' : 'disabledBtn'
          } ms-1`}
          onClick={() => setType('withdraw')}
        >
          WithDraw
        </button>
      </div> */}

      {type === "Payment Setting" && (
        <>
          <div className="payment-setting app-setting p-0">
            <div className=" card1">
              <div className="cardHeader p-3">
                <div className="row">
                  <div className="col-6 d-flex align-items-center">
                    <h5 className="mb-0 d-flex align-items-center ">Payment Setting</h5>
                  </div>
                  <div className="col-6 d-flex justify-content-end">
                    <Button type={`submit`} text={`Submit`} onClick={onsubmit} />
                  </div>
                </div>
              </div>
              <div className="row" style={{ padding: "15px" }}>
                {/* Stripe Setting Box */}
                <div className="col-12 col-md-6  ">
                  <div className="withdrawal-box payment-box">
                    <h6>Stripe Payment Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Stripe Android Switch (enable/disable stripe in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.isStripePay} onClick={() => handleSettingSwitch(setting?._id, 2)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Stripe IOS Switch (enable/disable stripe in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.stripeIosEnabled} onClick={() => handleSettingSwitch(setting?._id, 9)} />} />
                        </div>
                      </div>
                      <div className="col-12 withdrawal-input border-setting ">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="stripePublishableKey" className="">
                            Stripe publishable key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="stripePublishableKey"
                            value={stripePublishableKey}
                            placeholder={hasPermission ? "Enter Stripe Publishable Key" : `pk_test_51H8bQ9L5ZtMn7EXAMPLE`}
                            onChange={(e) => {
                              setStripePublishableKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  stripePublishableKey: ` stripePublishableKey Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  stripePublishableKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.stripePublishableKey}</p>}
                        </div>
                      </div>
                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="stripeSecretKey" className="">
                            Stripe secret key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="stripeSecretKey"
                            value={stripeSecretKey}
                            placeholder={hasPermission ? "Enter Stripe Secret Key" : "sk_test_51H8bQ9L5ZtMn7EXAMPLE"}
                            onChange={(e) => {
                              setStripeSecretKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  stripeSecretKey: ` Stripe Secret Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  stripeSecretKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.stripeSecretKey}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Razor Pay Setting Box */}
                <div className="col-12 col-md-6 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Razor Pay Payment Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Razor Pay Android Switch (enable/disable razor pay in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.isRazorPay} onClick={() => handleSettingSwitch(setting?._id, 1)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Razor Pay IOS Switch (enable/disable razor pay in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.razorpayIosEnabled} onClick={() => handleSettingSwitch(setting?._id, 8)} />} />
                        </div>
                      </div>
                      <div className="col-12 withdrawal-input border-setting ">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="razorPayId" className="">
                            Razor Pay Id
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="razorPayId"
                            value={razorPayId}
                            placeholder={hasPermission ? `Enter RazorPay Id` : "rzp_test_1DP5mmOlF5G5ag"}
                            onChange={(e) => {
                              setRazorPayId(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  razorPayId: ` razorPay Id Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  razorPayId: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.razorPayId}</p>}
                        </div>
                      </div>
                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="razorSecretKey" className="">
                            Razor Secret Key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="razorSecretKey"
                            value={razorSecretKey}
                            placeholder={hasPermission ? `Enter Razorpay Secret Key` : "rzp_test_fakeSecretKey1234567890"}
                            onChange={(e) => {
                              setRazorSecretKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  razorSecretKey: ` Razorpay Secret Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  razorSecretKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.razorSecretKey}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Flutter Wave Setting Box */}
                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Flutter Wave Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Flutter Wave Android Switch (enable/disable flutter wave in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.isFlutterWave} onClick={() => handleSettingSwitch(setting?._id, 4)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Flutter Wave IOS Switch (enable/disable flutter wave in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.flutterwaveIosEnabled} onClick={() => handleSettingSwitch(setting?._id, 10)} />} />
                        </div>
                      </div>

                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="flutterWaveKey" className="">
                            Flutter wave key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="flutterWaveKey"
                            value={flutterWaveKey}
                            placeholder={hasPermission ? `Enter FlutterWave Key` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setFlutterWaveKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  flutterWaveKey: `FlutterWave Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  flutterWaveKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.flutterWaveKey}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Google Play Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Google Play Android Switch (enable/disable Google Play in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.googlePaySwitch} onClick={() => handleSettingSwitch(setting?._id, 17)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Google Play IOS Switch (enable/disable Google Play in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.googlePlayIosEnabled} onClick={() => handleSettingSwitch(setting?._id, 18)} />} />
                        </div>
                      </div>

                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="googlePlayEmail" className="">
                            Google Play Email
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="googlePlayEmail"
                            value={googlePlayEmail}
                            placeholder={hasPermission ? `Enter Google Play Email` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setGooglePlayEmail(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  googlePlayEmail: `Google Play Email Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  googlePlayEmail: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.googlePlayEmail}</p>}
                        </div>

                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="googlePlayKey" className="">
                            Google Play Key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="googlePlayKey"
                            value={googlePlayKey}
                            placeholder={hasPermission ? `Enter Google Play Key` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setGooglePlayKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  googlePlayKey: `Google Play Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  googlePlayKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.googlePlayKey}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Pay Stack Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Pay Stack Android Switch (enable/disable Pay Stack in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.paystackAndroidEnabled} onClick={() => handleSettingSwitch(setting?._id, 11)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Pay Stack IOS Switch (enable/disable Pay Stack in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.paystackIosEnabled} onClick={() => handleSettingSwitch(setting?._id, 12)} />} />
                        </div>
                      </div>

                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="paystackPublicKey" className="">
                            Paystack Public Key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="paystackPublicKey"
                            value={paystackPublicKey}
                            placeholder={hasPermission ? `Enter Paystack Public Key` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setPaystackPublicKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  paystackPublicKey: `Paystack Public Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  paystackPublicKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.paystackPublicKey}</p>}
                        </div>

                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="paystackSecretKey" className="">
                            Paystack Secret Key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="paystackSecretKey"
                            value={paystackSecretKey}
                            placeholder={hasPermission ? `Enter Paystack Secret Key` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setPaystackSecretKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  paystackSecretKey: `Paystack Secret Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  paystackSecretKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.paystackSecretKey}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Cashfree Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Cashfree Android Switch (enable/disable Cashfree in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.cashfreeAndroidEnabled} onClick={() => handleSettingSwitch(setting?._id, 13)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Cashfree IOS Switch (enable/disable Cashfree in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.cashfreeIosEnabled} onClick={() => handleSettingSwitch(setting?._id, 14)} />} />
                        </div>
                      </div>

                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="cashfreeClientId" className="">
                            Cashfree Client Id
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="cashfreeClientId"
                            value={cashfreeClientId}
                            placeholder={hasPermission ? `Enter Cashfree Client Id` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setCashfreeClientId(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  cashfreeClientId: `Cashfree Client Id Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  cashfreeClientId: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.cashfreeClientId}</p>}
                        </div>

                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="cashfreeClientSecret" className="">
                            Cashfree Client Secret
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="cashfreeClientSecret"
                            value={cashfreeClientSecret}
                            placeholder={hasPermission ? `Enter Cashfree Client Secret` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setCashfreeClientSecret(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  cashfreeClientSecret: `Cashfree Client Secret Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  cashfreeClientSecret: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.cashfreeClientSecret}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Paypal Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Paypal Android Switch (enable/disable Paypal in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.paypalAndroidEnabled} onClick={() => handleSettingSwitch(setting?._id, 15)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Paypal IOS Switch (enable/disable Paypal in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.paypalIosEnabled} onClick={() => handleSettingSwitch(setting?._id, 16)} />} />
                        </div>
                      </div>

                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="paypalClientId" className="">
                            Paypal Client Id
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="paypalClientId"
                            value={paypalClientId}
                            placeholder={hasPermission ? `Enter Paypal Client Id` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setPaypalClientId(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  paypalClientId: `Paypal Client Id Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  paypalClientId: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.paypalClientId}</p>}
                        </div>

                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="paypalSecretKey" className="">
                            Paypal Client Secret
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="paypalSecretKey"
                            value={paypalSecretKey}
                            placeholder={hasPermission ? `Enter Paypal Client Secret` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setPaypalSecretKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  paypalSecretKey: `Paypal Client Secret Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  paypalSecretKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.paypalSecretKey}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Now Payment Setting Box */}
                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Now Payment Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Now Payment Android Switch (enable/disable Now Payment in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.nowPaymentAndroidEnabled} onClick={() => handleSettingSwitch(setting?._id, 19)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Now Payment IOS Switch (enable/disable Now Payment in app)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.nowPaymentIosEnabled} onClick={() => handleSettingSwitch(setting?._id, 20)} />} />
                        </div>
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Now Payment Test Switch (enable/disable Test Mode)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.nowPaymentIsTest} onClick={() => handleSettingSwitch(setting?._id, 21)} />} />
                        </div>
                      </div>

                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="nowPaymentApiKey" className="">
                            Now Payment Api Key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="nowPaymentApiKey"
                            value={nowPaymentApiKey}
                            placeholder={hasPermission ? `Enter Now Payment Api Key` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setNowPaymentApiKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  nowPaymentApiKey: `Now Payment Api Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  nowPaymentApiKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.nowPaymentApiKey}</p>}
                        </div>

                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="nowPaymentSandboxKey" className="">
                            Now Payment Sandbox Key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="nowPaymentSandboxKey"
                            value={nowPaymentSandboxKey}
                            placeholder={hasPermission ? `Enter Now Payment Sandbox Key` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setNowPaymentSandboxKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  nowPaymentSandboxKey: `Now Payment Sandbox Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  nowPaymentSandboxKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.nowPaymentSandboxKey}</p>}
                        </div>

                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="nowPaymentIpnSecret" className="">
                            Now Payment Ipn Secret
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="nowPaymentIpnSecret"
                            value={nowPaymentIpnSecret}
                            placeholder={hasPermission ? `Enter Now Payment Ipn Secret` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setNowPaymentIpnSecret(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  nowPaymentIpnSecret: `Now Payment Ipn Secret Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  nowPaymentIpnSecret: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.nowPaymentIpnSecret}</p>}
                        </div>

                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="nowPaymentPayCurrency" className="">
                            Now Payment Pay Currency
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="nowPaymentPayCurrency"
                            value={nowPaymentPayCurrency}
                            placeholder={hasPermission ? `Enter Now Payment Pay Currency` : "FLWSECK_TEST-xxxxxxxxxxxxxxxxxxxxx-X"}
                            onChange={(e) => {
                              setNowPaymentPayCurrency(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  nowPaymentPayCurrency: `Now Payment Pay Currency Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  nowPaymentPayCurrency: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.nowPaymentPayCurrency}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </>
      )}

      {type === "Setting" && (
        <>
          <div className="payment-setting app-setting p-0">
            <div className=" card1">
              <div className="cardHeader p-3">
                <div className="row">
                  <div className="col-6 d-flex align-items-center">
                    <h5 className="mb-0 d-flex align-items-center ">Genral Setting</h5>
                  </div>
                  <div className="col-6 d-flex justify-content-end">
                    <Button type={`submit`} text={`Submit`} onClick={onsubmit} />
                  </div>
                </div>
              </div>
              <div className="row" style={{ padding: "15px" }}>
                {/* App Setting Box */}
                <div className="col-lg-6 col-sm-12">
                  <div className="withdrawal-box payment-box">
                    <h6>App Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Maintenance Mode (enable/disable maintenance in app)</p>
                          {/* <ToggleSwitch
                          onClick={() => handleAppActive(setting?._id)}
                          value={setting?.maintenanceMode}
                        /> */}
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.maintenanceMode} onClick={() => handleAppActive(setting?._id)} />} />
                        </div>
                      </div>

                      <div className=" col-6 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="androidAppVersion" className="">
                            Android App Version 
                          </label>
                          <input
                            type="text"
                            className="rounded-2 form-control"
                            id="androidAppVersion"
                            value={androidAppVersion}
                            placeholder={hasPermission ? `Android App Version` : "1.0.0"}
                            onChange={(e) => {
                              setAndroidAppVersion(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  androidAppVersion: ` Android App Version Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  androidAppVersion: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.androidAppVersion}</p>}
                        </div>
                      </div>

                      <div className=" col-6 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="androidAppLink" className="">
                            Android App Link
                          </label>
                          <input
                            type="text"
                            className="rounded-2 form-control"
                            id="androidAppLink"
                            value={androidAppLink}
                            placeholder={hasPermission ? `Android App Link` : "https://androidapplink.com"}
                            onChange={(e) => {
                              setAndroidAppLink(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  androidAppLink: ` Android App Link Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  androidAppLink: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.androidAppLink}</p>}
                        </div>
                      </div>

                      <div className=" col-6 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="iosAppVersion" className="">
                            IOS App Version 
                          </label>
                          <input
                            type="text"
                            className="rounded-2 form-control"
                            id="iosAppVersion"
                            value={iosAppVersion}
                            placeholder={hasPermission ? `IOS App Version` : "1.0.0"}
                            onChange={(e) => {
                              setIosAppVersion(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  iosAppVersion: ` IOS App Version Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  iosAppVersion: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.iosAppVersion}</p>}
                        </div>
                      </div>

                      <div className=" col-6 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="iosAppLink" className="">
                            IOS App Link
                          </label>
                          <input
                            type="text"
                            className="rounded-2 form-control"
                            id="iosAppLink"
                            value={iosAppLink}
                            placeholder={hasPermission ? `Android App Link` : "https://iosapplink.com"}
                            onChange={(e) => {
                              setIosAppLink(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  iosAppLink: ` IOS App Link Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  iosAppLink: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.iosAppLink}</p>}
                        </div>
                      </div>

                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="privacyPolicyLink" className="">
                            Privacy policy link (redirect user to this link from app)
                          </label>
                          <input
                            type="text"
                            className="rounded-2 form-control"
                            id="privacyPolicyLink"
                            value={privacyPolicyLink}
                            placeholder={hasPermission ? `Privacy policy link` : "https://privacypolicygenerator.com"}
                            onChange={(e) => {
                              setPrivacyPolicyLink(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  privacyPolicyLink: ` privacyPolicyLink Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  privacyPolicyLink: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.privacyPolicyLink}</p>}
                        </div>
                      </div>

                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="tnc" className="">
                            Terms and condition
                          </label>
                          <input
                            type="text"
                            className="rounded-2 form-control"
                            id="tnc"
                            value={tnc}
                            placeholder={hasPermission ? `Enter tnc` : "https://termsgenerator.com"}
                            onChange={(e) => {
                              setTnc(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  tnc: ` Terms And Condition Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  tnc: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.tnc}</p>}
                        </div>
                      </div>
                      <div className=" col-12 withdrawal-input border-setting ">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="tax" className="">
                            Tax (%)
                          </label>
                          <input
                            type="number"
                            className="rounded-2 form-control"
                            id="tax"
                            value={tax}
                            placeholder={hasPermission ? `Enter Tax` : `15%`}
                            onChange={(e) => {
                              setTax(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  tax: ` tax Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  tax: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.tax}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Firebase Setting Box */}
                <div className="col-12 col-md-6 ">
                  <div className="withdrawal-box payment-box h-100">
                    <h6>Firebase Notification Setting</h6>

                    <div className="row">
                      <div className="col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label className="float-left" htmlFor="firebaseKey">
                            Private key JSON (use for firebase push notification in app)
                          </label>
                          <textarea
                            name="firebaseKey"
                            className=" mt-2"
                            id="firebaseKey"
                            rows={18}
                            value={firebaseKey}
                            placeholder={hasPermission ? `Enter firebaseKey` : JSON.stringify(fakeFirebaseJson, null, 2)}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              try {
                                const newData = JSON.parse(newValue);
                                setfirebaseKey(newValue);
                                setError("");
                              } catch (error) {
                                // Handle invalid JSON input
                                console.error("Invalid JSON input:", error);
                                setfirebaseKey(newValue);
                                return setError({
                                  ...error,
                                  firebaseKey: "Invalid JSON input",
                                });
                              }
                            }}
                          ></textarea>
                          {error.firebaseKey && (
                            <div className="pl-1 text-left">
                              <p className="errorMessage">{error.firebaseKey}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Charges Setting Box */}
                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Charges Setting</h6>
                    <div className="row">
                      <div className=" col-12 inputData withdrawal-input border-setting">
                        <label htmlFor="cancelOrderCharges">Cancel Order Charges (%)</label>
                        <input
                          type="text"
                          className="form-control"
                          id="cancelOrderCharges"
                          value={cancelOrderCharges}
                          placeholder={hasPermission ? "Enter Cancel Order Charges" : "100"}
                          onChange={(e) => {
                            setCancelOrderCharges(e.target.value);
                            if (!e.target.value) {
                              return setError({
                                ...error,
                                cancelOrderCharges: ` Cancel Order Charges Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                cancelOrderCharges: "",
                              });
                            }
                          }}
                        />
                        {error && <p className="errorMessage text-start">{error && error?.cancelOrderCharges}</p>}
                      </div>

                      <div className=" inputData col-12 withdrawal-input border-setting">
                        <label htmlFor="Admin Commission Charges (%)">Admin Commission Charges (%)</label>
                        <input
                          type="text"
                          className="form-control"
                          id="adminCommissionCharges"
                          value={adminCommissionCharges}
                          placeholder={hasPermission ? "Enter Admin Commission" : "20"}
                          onChange={(e) => {
                            setAdminCommissionCharges(e.target.value);
                            if (!e.target.value) {
                              return setError({
                                ...error,
                                adminCommissionCharges: ` Admin Commission Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                adminCommissionCharges: "",
                              });
                            }
                          }}
                        />
                        {error && <p className="errorMessage text-start">{error && error?.adminCommissionCharges}</p>}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Currency Setting Box */}
                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Currency Setting</h6>
                    <div className="row">
                      <div className="inputData col-12 withdrawal-input border-setting">
                        <label htmlFor="currencyName" className="">
                          Currency name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="currencyName"
                          value={currencyName}
                          placeholder={hasPermission ? "Enter currency Name" : "USD"}
                          onChange={(e) => {
                            setCurrencyName(e.target.value);
                            if (!e.target.value) {
                              return setError({
                                ...error,
                                currencyName: ` currency Name Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                currencyName: "",
                              });
                            }
                          }}
                        />
                        {error && <p className="errorMessage text-start">{error && error?.currencyName}</p>}
                      </div>

                      <div className="inputData col-12 withdrawal-input border-setting">
                        <label htmlFor="currencySymbol" className="">
                          Currency symbol
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="currencySymbol"
                          value={currencySymbol}
                          placeholder={hasPermission ? "Enter Currency Symbol" : "$"}
                          onChange={(e) => {
                            setCurrencySymbol(e.target.value);
                            if (!e.target.value) {
                              return setError({
                                ...error,
                                currencySymbol: ` Currency Symbol Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                currencySymbol: "",
                              });
                            }
                          }}
                        />
                        {error && <p className="errorMessage text-start">{error && error?.currencySymbol}</p>}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Product Request Setting Box */}
                <div className="col-12 col-md-6 mt-3  ">
                  <div className="withdrawal-box payment-box">
                    <h6>Product Request</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between mb-3">
                          <p className="m-0 fs-6 fw-medium">Add product request (enable/disable product request from seller)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.isAddProductRequest} onClick={() => handleSettingSwitch(setting?._id, 6)} />} />
                        </div>
                      </div>
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="align-items-center d-flex justify-content-between">
                          <p className="m-0 fs-6 fw-medium">Update product request (enable/disable product request from seller)</p>
                          <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={setting?.isUpdateProductRequest} onClick={() => handleSettingSwitch(setting?._id, 7)} />} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Email Setting Box */}
                <div className="col-12 col-md-6 mt-3 ">
                  <div className="withdrawal-box payment-box">
                    <h6>Email Setting</h6>
                    <div className="row">
                      <div className=" col-12 withdrawal-input border-setting">
                        <div className="inputData text  flex-row justify-content-start text-start">
                          <label htmlFor="resendKey" className="">
                            Resend Api Key
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="resendKey"
                            name={"resendKey"}
                            value={resendKey}
                            placeholder={hasPermission ? `Enter Resend API key` : `re_HDDJFDJdjf63742349djfbjd3dfnd`}
                            onChange={(e) => {
                              setResendKey(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  resendKey: ` Resend API Key Is Required`,
                                });
                              } else {
                                return setError({
                                  ...error,
                                  resendKey: "",
                                });
                              }
                            }}
                          />
                          {error && <p className="errorMessage text-start">{error && error?.resendKey}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {type === "Withdraw Setting" && (
        <>
          <div className=" app-setting p-0">
            <div className=" card1">
              <div className="cardHeader p-3">
                <div className="row">
                  <div className="col-6 d-flex align-items-center">
                    <h5 className="mb-0 d-flex align-items-center ">Withdraw Setting</h5>
                  </div>
                  <div className="col-6 d-flex justify-content-end">
                    <Button type={`submit`} text={`Submit`} onClick={onsubmit} />
                  </div>
                </div>
              </div>
              <div className=" px-3 py-2">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label htmlFor="minWithdrawalRequestedAmount" className="">
                    Minimum Withdrawal Request Amount
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="minWithdrawalRequestedAmount"
                    value={minWithdrawalRequestedAmount}
                    placeholder="Enter minWithdrawalRequestedAmount"
                    onChange={(e) => {
                      setMinWithdrawalRequestedAmount(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          razorSecretKey: `WithdrawalRequestedAmount Key Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          razorSecretKey: "",
                        });
                      }
                    }}
                  />
                  <p className="extention-show">User can not post withdraw request less than this amount</p>
                </div>
              </div>
            </div>

            <div className="userPage p-0">
              <div className="user-table mb-3">
                <div className="user-table-top">
                  <div className=" d-flex justify-content-between align-items-center w-100 ">
                    <div className="w-100">
                      <h5 className="main-title">Withdraw Payment Method</h5>
                    </div>
                    <div className="d-flex gap-2 justify-content-end w-100">
                      <Button
                        text={`Add`}
                        bIcon={<IconPlus size={18} />}
                        onClick={() => {
                          dispatch(openDialog({ type: "withdraw" }));
                        }}
                      />
                    </div>
                  </div>
                </div>

                <Table data={data} mapData={withDrawTable} PerPage={rowsPerPage} Page={page} type={"client"} />
                <Pagination
                  type={"client"}
                  serverPage={page}
                  setServerPage={setPage}
                  serverPerPage={rowsPerPage}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  totalData={data?.length}
                />
              </div>
            </div>

            {dialogue && dialogueType === "withdraw" && <WithDrawDialogue setData={setData} data={data} page={page} rowsPerPage={rowsPerPage} />}
          </div>
        </>
      )}
    </div>
  );
};
export default Setting;
